import React from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "../styles/PageBackBar.css"

export default function PageBackBar({ title = "", className = "" }) {
    const navigate = useNavigate();

    return (
        <div className={`page-backbar ${className}`}>
            <button
                className="page-backbar-btn"
                type="button"
                onClick={() => navigate(-1)}
                aria-label="Kembali"
                title="Kembali"
            >
                <FiArrowLeft />
            </button>

            <div className="page-backbar-title">{title}</div>
        </div>
    );
}
